import React, { useState, useEffect } from "react";
import { Card, Row, Col } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import UserPermissionTable from "components/partials/permissions/user-permission/UserPermissionTable";
import UserDropdown from "components/dropdowns/UserDropdown";
import { search } from "services/permissions/userPermissionServices";
import { BaseTableRQ } from "components/pages/stock-location/models/BaseTable"

export default function UserPermissionList() {
    const [userPermissions, setUserPermissions] = useState([]);
    const [total, setTotal] = useState(0);
    const [paging, setPaging] = useState(new BaseTableRQ(1, 100));
    const [selectedUser, setSelectedUser] = useState(null);
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        loadUserPermissions(paging);
    }, [])

    const loadUserPermissions = (pagingRq, userId = selectedUser) => {
        setIsSearching(true);
        search(pagingRq, userId).then(res => {
            if (res) {
                setUserPermissions(res.items);
                setTotal(res.total);
            }
        })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setIsSearching(false);
            });

        setPaging(pagingRq);
    }

    const handleUserChange = (option) => {
        const userId = option?.value ?? null;
        setSelectedUser(userId);
        paging.pageNum = 1;
        loadUserPermissions(paging, userId);
    }

    const gotoPage = (index) => {
        index += 1;
        if (index <= 0) return;
        paging.pageNum = index;
        loadUserPermissions(paging);
    }

    const nextPage = () => {
        const page = paging.pageNum + 1;
        if (page > Math.ceil(total / paging.pageSize)) return;
        paging.pageNum = page;
        loadUserPermissions(paging);
    }

    const previousPage = () => {
        const page = paging.pageNum - 1;
        if (page <= 0) return;
        paging.pageNum = page;
        loadUserPermissions(paging);
    }

    return (
        <>
            <PageHeader
                title="User Permission List"
                description={`Manage and view all available User Permission from this page.`}
                className="mb-3"
            ></PageHeader>
            <Card>
                <Card.Body className="overflow-hidden p-lg-6">
                    <Row className="align-items-center mb-3">
                        <Col md={4}>
                            <label style={{ marginBottom: '0.25rem', display: 'block' }}>
                                Search by user
                            </label>
                            <UserDropdown
                                isMulti={false}
                                showLogin
                                isClearable
                                selectedOptions={selectedUser}
                                handleChange={handleUserChange}
                            />
                        </Col>
                        {isSearching && (
                            <Col md={2} style={{ paddingTop: '1.75rem' }}>
                                Searching...
                            </Col>
                        )}
                    </Row>
                    <Row className="align-items-center justify-content-between">
                        <UserPermissionTable
                            data={userPermissions}
                            paging={paging}
                            total={total}
                            nextPage={nextPage}
                            previousPage={previousPage}
                            gotoPage={gotoPage}
                        />
                    </Row>
                </Card.Body>
            </Card>
        </>)
}